module.exports = __webpack_public_path__ + "static/media/insurance-home-640.92df200a.jpg";